import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import { Container } from "react-bootstrap";
import { FaSuitcase, FaSun } from "react-icons/fa"; // Icons

import Navr from "../Navbar/Navr";
import Footer from "./Footer";
import Domestic from "./Domestic";
import Summer from "./Summer";

// Image Import (Background ke liye)
import bgImage from "../Ecomphotos/wayanad.jpg";

export default function Packages() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="packages-wrapper">
      <Navr />

      {/* --- Section 1: Hero Banner --- */}
      <div
        className="packages-hero d-flex align-items-center justify-content-center"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="hero-overlay"></div>
        <Container className="text-center position-relative z-2">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h5 className="text-warning text-uppercase ls-2 mb-3">
              Your Journey Begins Here
            </h5>
            <h1 className="display-4 fw-bold text-white mb-4">
              Curated Tour Packages
            </h1>
            <p
              className="text-white lead mx-auto opacity-75 mb-5"
              style={{ maxWidth: "700px" }}
            >
              From the royal forts of Rajasthan to the cool breezes of Summer
              retreats, find the perfect itinerary for your next adventure.
            </p>

            {/* Quick Navigation Buttons */}
            <div className="d-flex justify-content-center gap-3">
              <a
                href="#domestic-section"
                className="btn btn-danger rounded-pill px-4 py-2 fw-bold shadow hover-scale"
              >
                <FaSuitcase className="me-2" /> Domestic Tours
              </a>
              <a
                href="#summer-section"
                className="btn btn-light text-danger rounded-pill px-4 py-2 fw-bold shadow hover-scale"
              >
                <FaSun className="me-2" /> Summer Specials
              </a>
            </div>
          </motion.div>
        </Container>
      </div>

      {/* --- Section 2: Domestic Packages --- */}
      <div id="domestic-section" className="section-padding bg-light">
        <Container>
          <div className="section-header text-center mb-5">
            <span className="badge bg-danger mb-2 px-3 py-2">Most Popular</span>
            <h2 className="fw-bold display-6">Explore India</h2>
            <div className="separator mx-auto"></div>
          </div>
          <Domestic />
        </Container>
      </div>

      {/* --- Visual Divider / Offer Strip --- */}
      <section className="offer-strip py-5 text-center text-white">
        <Container>
          <h3 className="fw-bold">⚡ Limited Time Offer</h3>
          <p className="mb-0">
            Get flat <span className="text-warning fw-bold">10% OFF</span> on
            advance bookings for Summer Packages!
          </p>
        </Container>
      </section>

      {/* --- Section 3: Summer Packages --- */}
      <div id="summer-section" className="section-padding bg-white">
        <Container>
          <div className="section-header text-center mb-5">
            <span className="badge bg-warning text-dark mb-2 px-3 py-2">
              Beat the Heat
            </span>
            <h2 className="fw-bold display-6">Summer Specials</h2>
            <div className="separator mx-auto"></div>
          </div>
          <Summer />
        </Container>
      </div>

      {/* --- Bottom CTA --- */}
      <div className="text-center py-5 bg-light-gray">
        <h4 className="fw-bold mb-3">Confused? Let us help you plan!</h4>
        <a href="/contact" className="btn btn-outline-dark rounded-pill px-5">
          Talk to an Expert
        </a>
      </div>

      <Footer />
    </div>
  );
}
